export default function MySQL_TIMEDIFF() {
  return (
    <div>
      <h2>MySQL_TIMEDIFF</h2>    </div>
  );
}